<template>
  <ValidationObserver ref="organizationForm" v-slot="{ invalid, passes }">
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-form rel="organizationForm" @submit.prevent="passes(save)">
        <v-card class="elevation-1 mb-6 rounded-lg">
          <v-card-title class="pa-7">
            {{ title }}
          </v-card-title>
          <v-card-text class="pl-7 pr-7 pt-7">
            <v-row>
              <v-col cols="12" md="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.name"
                  rules="required"
                  outlined
                  dense
                  label="Název"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VFileInputWithValidation
                  v-model="bannerFiles"
                  :rules="{
                    required: !edit,
                    ext: ['png'],
                  }"
                  prepend-icon=""
                  append-icon="$file"
                  :clearable="false"
                  outlined
                  counter
                  :show-size="1000"
                  label="Nahrajte banner (.png)"
                  @change="setBannerFile($event)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.type"
                  label="Typ"
                  rules="required"
                  outlined
                  dense
                  background-color="white"
                  :items="types"
                  item-text="text"
                  item-value="name"
                  :loading="typesLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.status"
                  label="Stav"
                  rules="required"
                  outlined
                  dense
                  background-color="white"
                  :items="statuses"
                  item-text="text"
                  item-value="name"
                  :loading="statusesLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VTextEditorWithValidation
                  v-model="value.content"
                  rules="required"
                  outlined
                  dense
                  label="Obsah"
                  data-cy="content"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" class="py-0 px-5">
                <v-radio-group v-model="condition" row>
                  <v-radio label="Podmínka" value="condition"></v-radio>
                  <v-radio label="Zákazníci" value="customers"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-if="condition === 'condition'"
                  v-model.trim="value.condition"
                  class="pb-0"
                  label="Podmínka"
                  :rules="{
                    required: condition === 'condition',
                  }"
                  outlined
                  dense
                  background-color="white"
                  :items="conditions"
                  item-text="text"
                  item-value="name"
                  :loading="conditionsLoading"
                  :clearable="true"
                  :custom-slot="true"
                >
                  <template slot="item" slot-scope="{ item }">
                    <v-row class="ma-0 pa-0 pt-2 pb-2">
                      <v-col class="ma-0 pa-0">
                        <v-row class="ma-0 pa-0">
                          <v-col class="ma-0 pa-0" style="font-size: 13px">
                            {{ item.text }}
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                          <v-col
                            v-for="(type, index) in item.orderTypes"
                            :key="index"
                            cols="auto"
                            class="ma-0 pa-0"
                          >
                            <span
                              v-if="index === item.orderTypes.length - 1"
                              style="font-size: 13px; font-weight: bold"
                            >
                              {{ type.text }}
                            </span>
                            <span
                              v-else
                              style="font-size: 13px; font-weight: bold; padding-right: 3px"
                            >
                              {{ type.text }},
                            </span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                          <template v-if="item.orderStatusFrom.name === item.orderStatusTo.name">
                            <v-col cols="auto" class="ma-0 pa-0" style="font-size: 13px">
                              <span style="font-size: 13px; font-weight: bold">
                                {{ item.orderStatusFrom.text }}
                              </span>
                            </v-col>
                          </template>
                          <template v-else>
                            <v-col cols="auto" class="ma-0 pa-0" style="font-size: 13px">
                              <span style="font-size: 13px; font-weight: bold; padding-right: 3px">
                                {{ item.orderStatusFrom.text }}
                              </span>
                            </v-col>
                            <v-col cols="auto" class="ma-0 pa-0" style="font-size: 13px">
                              <span style="font-size: 13px; font-weight: bold">
                                => {{ item.orderStatusTo.text }}
                              </span>
                            </v-col>
                          </template>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                  <template slot="selection" slot-scope="{ item }">
                    <v-row class="ma-0 pa-0 pt-2 pb-2 cut-text-100ps-80" align="center">
                      <v-col class="ma-0 pa-0">
                        <v-row class="ma-0 pa-0 mb-1" align="center">
                          <v-col class="ma-0 pa-0" style="font-size: 15px">
                            {{ item.text }}
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0 mb-1" align="center">
                          <v-col
                            v-for="(type, index) in item.orderTypes"
                            :key="index"
                            cols="auto"
                            class="ma-0 pa-0"
                          >
                            <span
                              v-if="index === item.orderTypes.length - 1"
                              style="font-size: 15px; font-weight: bold"
                            >
                              {{ type.text }}
                            </span>
                            <span
                              v-else
                              style="font-size: 15px; font-weight: bold; padding-right: 3px"
                            >
                              {{ type.text }},
                            </span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0" align="center">
                          <template v-if="item.orderStatusFrom.name === item.orderStatusTo.name">
                            <v-col cols="auto" class="ma-0 pa-0">
                              <span style="font-size: 15px; font-weight: bold">
                                {{ item.orderStatusFrom.text }}
                              </span>
                            </v-col>
                          </template>
                          <template v-else>
                            <v-col cols="auto" class="ma-0 pa-0">
                              <span style="font-size: 15px; font-weight: bold; padding-right: 3px">
                                {{ item.orderStatusFrom.text }}
                              </span>
                            </v-col>
                            <v-col cols="auto" class="ma-0 pa-0">
                              <span style="font-size: 15px; font-weight: bold">
                                až {{ item.orderStatusTo.text }}
                              </span>
                            </v-col>
                          </template>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </VAutocompleteWithValidation>
                <VFileInputWithValidation
                  v-else
                  v-model="customerFiles"
                  :rules="{
                    required: condition === 'customers',
                    ext: ['xlsx'],
                  }"
                  prepend-icon=""
                  append-icon="$file"
                  :clearable="false"
                  outlined
                  counter
                  :show-size="1000"
                  label="Zákazníci (.xlsx)"
                  @change="setCustomerFile($event)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2" class="py-0 px-5">
                <VDatePickerWithValidation
                  v-model="value.validSince"
                  date-format="dd.MM.yyyy"
                  rules="required"
                  outlined
                  dense
                  label="Platnost od"
                />
              </v-col>
              <v-col cols="12" sm="2" class="py-0 px-5">
                <VDatePickerWithValidation
                  v-model="value.validUntil"
                  date-format="dd.MM.yyyy"
                  rules="required"
                  outlined
                  dense
                  label="Platnost do"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VFileInputWithValidation
                  v-model="attachmentsFiles"
                  prepend-icon=""
                  append-icon="$file"
                  :clearable="false"
                  outlined
                  counter
                  multiple
                  :show-size="1000"
                  label="Přílohy"
                  @change="setAttachmentFile($event)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <div class="request-label">Zákazník - zobrazení</div>
                <div class="request-value mt-0">
                  <v-checkbox
                    v-model="value.clientEnabled"
                    :label="`${value.clientEnabled ? 'Zapnuto' : 'Vypnuto'}`"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                height="40px"
                min-width="130px"
                color="primary"
                depressed
                :loading="loading"
              >
                Uložit
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-skeleton-loader>
  </ValidationObserver>
</template>

<script>
import VTextEditorWithValidation from '../validators/VTextEditorWithValidation'
import VDatePickerWithValidation from '../validators/VDatePickerWithValidation'
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '../validators/VAutocompleteWithValidation'

export default {
  name: 'OfferForm',
  components: { VAutocompleteWithValidation, VDatePickerWithValidation, VTextEditorWithValidation },
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    edit: {
      type: Boolean,
      default: false,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      types: [],
      typesLoading: false,
      statuses: [],
      statusesLoading: false,
      conditions: [],
      conditionsLoading: false,
      condition: 'condition',
      bannerFiles: null,
      customerFiles: null,
      attachmentsFiles: null,
    }
  },
  watch: {
    condition: {
      handler() {
        this.value.condition = null
        this.bannerFiles = null
        this.customerFiles = null
        this.attachmentsFiles = null
      },
    },
  },
  created() {
    this.loadOfferTypes()
    this.loadOfferStatuses()
    this.loadOfferConditions()
  },
  methods: {
    ...mapActions({
      listPersonalizedOfferTypes: 'enum/listPersonalizedOfferTypes',
      listPersonalizedOfferStatuses: 'enum/listPersonalizedOfferStatuses',
      listPersonalizedOfferConditions: 'enum/listPersonalizedOfferConditions',
    }),
    loadOfferTypes() {
      this.typesLoading = true
      this.listPersonalizedOfferTypes()
        .then((response) => {
          this.types = response.data
        })
        .finally(() => {
          this.typesLoading = false
        })
    },
    loadOfferStatuses() {
      this.statusesLoading = true
      this.listPersonalizedOfferStatuses()
        .then((response) => {
          this.statuses = response.data
        })
        .finally(() => {
          this.statusesLoading = false
        })
    },
    loadOfferConditions() {
      this.conditionsLoading = true
      this.listPersonalizedOfferConditions()
        .then((response) => {
          this.conditions = response.data
        })
        .finally(() => {
          this.conditionsLoading = false
        })
    },
    setBannerFile(event) {
      this.bannerFiles = event
    },
    setCustomerFile(event) {
      this.customerFiles = event
    },
    setAttachmentFile(event) {
      this.attachmentsFiles = event
    },
    save() {
      this.$emit('save', {
        value: this.value,
        bannerFiles: this.bannerFiles,
        customerFiles: this.customerFiles,
        attachmentsFiles: this.attachmentsFiles,
      })
    },
  },
}
</script>
